import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManagePrinters() {
   const ALL_OPTS = { value: 0, label: "-- Select --" };
   const INIT_MODEL = { Id: 0, DPI: null, IPAddress: "", Name: "", Path: "", PrinterType: 0 };
   const [dpi, setDpi] = useState("");
   const [editId, setEditId] = useState(0);
   const [editPrinter, setEdit] = useState(INIT_MODEL);
   const [ipAddress, setIp] = useState("");
   const [isAdd, setAdd] = useState(false);
   const [name, setName] = useState("");
   const [newPrinter, setNew] = useState(INIT_MODEL);
   const [printerList, setPrinters] = useState([]);
   const [spinPrinter, setSpinPrinter] = useState(true);
   const [typeList, setTypes] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "printer", value: ALL_OPTS },
      { filterName: "type", value: ALL_OPTS },
   ]);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function DeletePrinter() {
      setSpinPrinter(true);
      api.post(`Printer/DeletePrinter/${editId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Printer was successfully deleted!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinPrinter(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinPrinter(false);
         });
   }

   function onCreatePrinter() {
      setEditId(0);
      setDpi("");
      setIp("");
      setName("");
      setEdit(INIT_MODEL);
      setNew(INIT_MODEL);

      const p = _.find(printerList, (x) => x.value === 0);
      const t = _.find(typeList, (t) => t.value === 0);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "printer",
         value: p,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "type",
         value: t,
      });
      setFilters(newFilters);
      setAdd(true);
   }

   function onPrinterChange(newFilterValue) {
      setAdd(false);
      setNew(INIT_MODEL);
      const p = _.find(printerList, (x) => x.value === newFilterValue.value);
      const t = _.find(typeList, (t) => t.value === p.TypeId);

      if (newFilterValue.value <= 0) {
         // Reset
         setEdit(INIT_MODEL);
         setDpi("");
         setIp("");
         setName("");
      }
      else {
         // Get the selected printer
         setDpi(p.DPI);
         setIp(p.IP);
         setName(newFilterValue.label);
         let changes = Object.assign({}, INIT_MODEL);
         changes.Id = newFilterValue.value;
         changes.Name = newFilterValue.label;
         changes.Path = newFilterValue.label;
         changes.IPAddress = p.IP;
         changes.DPI = p.DPI;
         changes.PrinterType = p.TypeId;
         setEdit(changes);
      }

      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "printer",
         value: p,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "type",
         value: t,
      });
      setFilters(newFilters);
      setEditId(newFilterValue.value <= 0 ? 0 : newFilterValue.value);
   }

   function onTypeChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      if (isAdd) {
         let changes = Object.assign({}, newPrinter);
         changes.PrinterType = newFilterValue.value;
         setNew(changes);
      }
      else if (editPrinter.Id > 0) {
         let changes = Object.assign({}, editPrinter);
         changes.PrinterType = newFilterValue.value;
         setEdit(changes);
      }
   }

   function runQuery() {
      setSpinPrinter(true);
      api
         .fetch(`Printer/LoadPrintLists`)
         .then((response) => {
            if (response.data.success) {
               const pList = _.concat([ALL_OPTS],
                  _.map(response.data.printers, (p) => ({
                     value: p.id,
                     label: p.nameOnly,
                     DPI: p.dpi,
                     IP: p.ipAddress,
                     TypeId: p.printerType
                  })));
               const tList = _.concat([ALL_OPTS],
                  _.map(response.data.types, (t) => ({
                     value: t.id,
                     label: t.name
                  })));
               return { pList: pList, tList: tList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ pList, tList }) => {
            setPrinters(pList);
            setTypes(tList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            const p = _.find(printerList, (x) => x.value === 0);
            const t = _.find(typeList, (t) => t.value === 0);
            let newFilters = filterHelpers.getFilters(filters, {
               filterName: "printer",
               value: p,
            });
            newFilters = filterHelpers.getFilters(newFilters, {
               filterName: "type",
               value: t,
            });
            setFilters(newFilters);
            setAdd(false);
            setEditId(0);
            setDpi("");
            setIp("");
            setName("");
            setEdit(INIT_MODEL);
            setNew(INIT_MODEL);
            setSpinPrinter(false);
         });
   }

   function SavePrinter() {
      let payload = Object.assign({}, isAdd ? newPrinter : editPrinter);
      if (payload.PrinterType <= 0) {
         toast.error("A printer type is required");
         return;
      }
      if (!name || name === "") {
         toast.error("Printer name is required");
         return;
      }
      if (!ipAddress || ipAddress === "") {
         toast.error("IP address is required");
         return;
      }
      if (payload.PrinterType === 1 || payload.PrinterType === 3) {
         if (!dpi || dpi === "") { // Label printers need a DPI
            toast.error("A DPI is required");
            return;
         }
      }
      payload.IPAddress = ipAddress;
      payload.DPI = dpi === "" ? null : dpi;
      if (payload.Name !== name) {
         payload.Name = name;
         payload.Path = name;
      }

      setSpinPrinter(true);
      api.post('Printer/SavePrinter', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success(`Printer ${isAdd ? 'added' : 'saved'}!`);
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinPrinter(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinPrinter(false);
         });
   }

   const ShowDeleteModal = () => {
      if (editId === 0) {
         toast.error("Please select a printer");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the selected printer?`,
         buttons: [
            { label: "Yes", onClick: () => { DeletePrinter() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinPrinter}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Button title="Add" className="shredButton" onClick={() => onCreatePrinter()}>
                              Add New Printer
                           </Button>
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {printerList && printerList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Printer:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="printer"
                                             options={printerList}
                                             value={filterHelpers.getValue(filters, "printer")}
                                             onChangeCallback={e => onPrinterChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
                     <hr />

                     {isAdd || editId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    {editPrinter && editPrinter.Id > 0 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width95px noWrap h6">
                                             Id: {editPrinter.Id}
                                          </td>
                                          <td colSpan={2} className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Type:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="type"
                                             options={typeList}
                                             value={filterHelpers.getValue(filters, "type")}
                                             onChangeCallback={e => onTypeChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Name:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={name || ""}
                                             onChange={(e) => setName(e.target.value)}
                                             maxLength="99"
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          IP Address:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={ipAddress || ""}
                                             onChange={(e) => setIp(e.target.value)}
                                             maxLength="20"
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          DPI:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={dpi || ""}
                                             onChange={(e) => setDpi(e.target.value)}
                                             maxLength="3"
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Button
                                             title="Save"
                                             className="shredButton"
                                             onClick={() => SavePrinter()}
                                          >
                                             Save
                                          </Button>
                                          &nbsp;&nbsp;&nbsp;
                                          {editId > 0 ? (
                                             <Button
                                                title="Delete"
                                                className="shredButton buttonRight"
                                                onClick={() => ShowDeleteModal()}
                                             >
                                                Delete
                                             </Button>
                                          ) : null}
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
